// src/pages/Home.js
import React from 'react';
import Header from '../components/Header';
import ServiceList from '../components/ServiceList';
import ContactForm from '../components/ContactForm';
import '../styles/main.css';
// import { Link } from 'react-router-dom';
import AboutUs from './AboutUs';
import Team from './Team';
import Offers from './Offers';

function Home() {
  return (
    <div>
      <Header />
      <Offers />
      <Team />
      <ServiceList />
      <AboutUs />
      <ContactForm />
    </div>
  );
}

export default Home;